import {
  IConfigurationParams,
  ConfigurationNames,
} from '../../../../graphql/configuration/models/configuration.models';

export const getMyopiaControlEnabled = (configuration: IConfigurationParams[]): boolean => {
  const myopiaControlParams = configuration.find((
    params,
  ) => params.name === ConfigurationNames.myopiaControl);

  return myopiaControlParams ? JSON.parse(myopiaControlParams.configuration).enabled : false;
};
